// extracted by mini-css-extract-plugin
module.exports = {"logo":"home_logo_6WOFD","wide":"home_wide_2aQDE","body":"home_body_22K0H","footer":"home_footer_VfuM2","terms-link":"home_terms-link_1DKih"};